import requesta from '@/base/service'
const baseURL = process.env.VUE_APP_BASE_API_AI
const request = (data) => {
  return requesta({ ...data, ...{ baseURL } })
}
const requestLocal = (data) => {
  return requesta({ ...data, ...{ baseURL: '/apiCX' } })//
}

//  查询产业链分类 （第一层级用作路由）
export function queryIndustryChain(data) {
  return request({
    url: '/industry/queryIndustryChain',
    method: 'get',
    params: data
  })
}

// 省市区code获取区域信息
export function getSelectArea(data) {
  return request({
    url: '/advancedSearch/selectArea',
    method: 'get',
    params: data
  })
}

// 获取国际行业
export function getIndustryInfo(data) {
  return request({
    url: '/company/industryInfo',
    method: 'get',
    params: data
  })
}



// 地域信息
export function getGeoJson(data) {
  return request({
    url: '/productCustomer/enterprise/geoJson',
    method: 'post',
    data
  })
}



